import { render, staticRenderFns } from "./Judgelib.vue?vue&type=template&id=506f054d&"
import script from "./Judgelib.vue?vue&type=script&lang=js&"
export * from "./Judgelib.vue?vue&type=script&lang=js&"
import style0 from "./Judgelib.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports